<template>
  <div ref="autoplayerWrapper">
    <slot></slot>
    <div
      ref="videoPlayer"
      :isplayingvideo="isPlayingVideo"
      class="video-player"
      :data-vimeo-url="vimeoVideoUrl"
      :id="playerId"
    ></div>
  </div>
</template>

<script>
import Vimeo from "@vimeo/player";

export default {
  name: "AutoPlayer.vue",
  props: {
    playerId: {
      required: true,
      type: String,
    },
    vimeoVideoUrl: {
      required: false,
      type: String,
    },
    selectedTileId: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      player: null,
      playerWidth: 0,
      playerHeight: 0,
      options: {
        controls: false,
      },
      timeoutId: 0,
      isLoaded: false,
      isIntersectingVideo: false,
    };
  },
  computed: {
    isMobile() {
      const platform = navigator.userAgent.toLowerCase();
      return /(android|webos|iphone|ipad|ipod|blackberry|windows phone)/.test(
        platform
      );
    },
    isPlayingVideo() {
      return this.playerId === this.selectedTileId;
    },
  },
  watch: {
    isPlayingVideo(val) {
      try {
        if (val && this.vimeoVideoUrl && this.vimeoVideoUrl !== "") {
          this.onPlayVideoHandler();
        } else {
          this.onPauseVideoHandler();
        }
      } catch (_) {}
    },
  },
  mounted() {
    if (this.vimeoVideoUrl && this.vimeoVideoUrl !== "") {
      setTimeout(() => {
        this.onComputedSizeHandler();

        if (this.isMobile) {
          this.onIntersectionHandler(autoplayerWrapper.parentElement);
        }

        this.isLoaded = true;
      }, 1000);
    }
  },
  methods: {
    onIntersectionHandler(element) {
      const configuration = {
        rootMargin: "-50% 0% -50% 0%",
        threshold: 0,
      };

      const observer = new IntersectionObserver((entries) => {
        if (this.isLoaded) {
          if (
            entries[0].isIntersecting &&
            this.playerId !== this.selectedTileId
          ) {
            window.clearTimeout(this.timeoutId);

            this.timeoutId = setTimeout(() => {
              this.onPlayVideoHandler();
            }, 300);
          } else {
            this.onPauseVideoHandler();
          }
        }
      }, configuration);

      observer.observe(element);
    },
    onPlayVideoHandler() {
      this.options.autoplay = !navigator.userActivation.isActive;
      this.options.muted = true; //!navigator.userActivation.isActive;

      if (!this.player) {
        this.player = new Vimeo(this.playerId, this.options);
        this.player.ready().then(this.onComputedSizeHandler());
      }

      this.player.setMuted(this.options.muted);
      this.player.play();
      this.$emit("on:selectidchange", this.playerId);

      this.onComputedSizeHandler();
    },
    onPauseVideoHandler() {
      if (!this.player) {
        return;
      }

      this.player.pause();

      this.onComputedSizeHandler();
    },
    onComputedSizeHandler() {
      const autoplayerWrapper = this.$refs.autoplayerWrapper;

      const wrapperHeight = autoplayerWrapper.parentElement.clientHeight;
      const wrapperWidth = autoplayerWrapper.parentElement.clientWidth;

      if (wrapperWidth > wrapperHeight) {
        this.options.width = wrapperWidth;
      } else {
        this.options.height = wrapperHeight;
      }

      const videoPlayer = this.$refs.videoPlayer;
      const iframe = videoPlayer.firstChild;

      if (iframe) {
        const iframeWidth = iframe.clientWidth;
        const iframeHeight = iframe.clientHeight;

        if (wrapperHeight > iframeHeight) {
          const scale = iframeHeight / wrapperHeight + 1;

          iframe.style.transform = `scale(${scale})`;
        } else if (wrapperWidth > iframeWidth) {
          const scale = iframeWidth / wrapperWidth + 1;

          iframe.style.transform = `scale(${scale})`;
        }
      }
    },
  },
};
</script>

<style scoped>
.video-player {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -10;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-left: 50%;
  transform: translateX(-50%);
}

.video-player[isplayingvideo] {
  z-index: 1;
}
</style>
